/**
 * Hook for managing channel notification level
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getChannelNotificationLevel,
  updateChannelNotificationLevel,
} from '@/services/channels.service';

/**
 * Get channel notification level
 */
export const useChannelNotificationLevel = (channelId: string) => {
  return useQuery({
    queryKey: ['channelNotificationLevel', channelId],
    queryFn: () => getChannelNotificationLevel(channelId),
    enabled: !!channelId,
  });
};

/**
 * Update channel notification level
 */
export const useUpdateChannelNotificationLevel = (channelId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationLevel: 'all' | 'mentions' | 'none') =>
      updateChannelNotificationLevel(channelId, notificationLevel),
    onSuccess: () => {
      // Invalidate channel notification level query
      queryClient.invalidateQueries({
        queryKey: ['channelNotificationLevel', channelId],
      });

      // Invalidate channels list to refresh any mute indicators
      queryClient.invalidateQueries({
        queryKey: ['channels'],
      });
    },
  });
};
